import React, { Component } from "react";
import { Layout, Menu, Button } from 'antd';
import { useNavigate } from "react-router-dom";
import { MenuUnfoldOutlined, MenuFoldOutlined, AppstoreFilled, DollarOutlined,
    TagsOutlined,DashboardOutlined ,UserOutlined,LineChartOutlined,SettingOutlined, ProfileOutlined} from "@ant-design/icons";
import {BsBoxSeam,BsShieldCheck} from "react-icons/bs"
import SubMenu from "antd/lib/menu/SubMenu";
import {IconCuenta} from "../../Widgets/Iconos"
import usePermissions from "../../../Hooks/usePermissions";
import User from "../../../Hooks/Logged";

const { Sider } = Layout;

class Sidebar extends Component {

    constructor(props) {
        super(props)
        this.state = {
            collapsed: false
        }
    }


    /**
     *
     *
     * @memberof AdminSidebar
     */
    toogle = () => {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    }

    render() {

        const { props } = this

        return (
            <Sider
                theme="light"
                width={250}
                collapsedWidth={0}
                breakpoint="lg"

                className="custom-sider sider-width"
            //collapsed={this.state.collapsed}
            //collapsible
            >

                <Menu
                    mode="inline"
                    theme="light"
                    className="heigth-100 "
                    style={{ borderRight: 0 }}
                >
                    <Button ghost onClick={this.toogle} className="no-border">
                        {this.state.collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                    </Button>


                    <Menu.ItemGroup key="navegacion" title="NAVEGACIÓN">

                        <Menu.Item key="pedidos" icon={<DashboardOutlined  />} onClick={() => this.props.navigate("/customer/pedidos", { replace: true })}>
                            Mis Pedidos
                        </Menu.Item>
                        <Menu.Item key="direcciones" icon={<ProfileOutlined />} onClick={() => this.props.navigate("/customer/addresses", { replace: true })}>
                            Mi Cuenta
                        </Menu.Item>

                    </Menu.ItemGroup>

                </Menu>

            </Sider>
        )
    }
}

export default function View(props) {

    const user = React.useContext(User)
    return <Sidebar {...props} navigate={useNavigate()} />
}